"use client";

import { motion } from "motion/react";
import React from "react";

export function ContactHeader() {
    return (
        <div className="relative pt-48 pb-24 flex flex-col items-center justify-center text-center z-10 px-4">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 backdrop-blur-md mb-10"
            >
                <div className="w-2 h-2 rounded-full bg-green-400 animate-pulse" />
                <span className="text-xs font-semibold uppercase tracking-widest text-slate-300">
                    Accepting New Engagements
                </span>
            </motion.div>
            
            <motion.h1 
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
                className="text-5xl md:text-7xl lg:text-8xl font-light tracking-tight text-white mb-8"
            >
                Start a <span className="font-serif italic text-white/70">Conversation</span>
            </motion.h1>
            
            <motion.p 
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
                className="text-lg md:text-xl text-slate-400 max-w-2xl font-light leading-relaxed mx-auto"
            >
                Whether you need an Architecture Discovery session or a dedicated partnership, choose how you&apos;d like to proceed below.
            </motion.p>
        </div>
    );
}
